var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"procedures-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.procedures),function(procedure){return _c('i-col',{key:procedure.id,attrs:{"span":"24"}},[_c('procedures-item',{attrs:{"procedure":procedure,"all":_vm.all,"object":_vm.object},on:{"open-procedure":_vm.openProcedure}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }